import Loading from '@common/components/Loading';
import { authenticationRouting } from '@common/hooks/authenticationRoute';
import useWatchRecords from '@common/hooks/useWatchRecord';
import { IAppInfo } from '@common/types/element';
import { animatedScreen } from '@common/utils';
import { isEmpty } from 'lodash';
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { Animated, Platform, View } from 'react-native';
import AnimationWrapper from '../../components/Animation/NormalAnimation';
import ErrorComponent from './ErrorComponent';
import ForgotPassword from './ForgotPassword';
import ResetPassword from './ForgotPassword/ResetPassword';
import Render from './Render';

let SplashScreen: any;

(async () => {
  if (Platform.OS !== 'web') {
    SplashScreen = await (await import('react-native-splash-screen')).default;
  }
})();

type Props = {
  appInfo: IAppInfo;
};

function RenderScreen({ appInfo }: Props) {
  const {
    screen,
    animation,
    modalScreen,
    modalTransition,
    loading,
    dimension,
    isForgotPassword,
    isShowResetPassword,
    auth,
    locale,
  }: any = authenticationRouting({ appInfo });

  if (Platform.OS !== 'web') {
    SplashScreen.hide();
  }

  if (loading) {
    return <Loading />;
  }
  if (!screen) {
    return (
      <Fragment>
        <View
          style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            width: dimension.width,
            height: dimension.height,
            backgroundColor: 'white',
          }}
        >
          {/* <Text>Not found screen on App</Text> */}
        </View>
      </Fragment>
    );
  }

  return (
    <Fragment>
      <Helmet>
        <title>{`${appInfo?.name} | ${screen?.name}`}</title>
        <script
          async
          src={`https://www.googletagmanager.com/gtag/js?id=${appInfo.metadata.ga4?.id}`}
        ></script>
        <script>
          {` window.dataLayer = window.dataLayer || [];
         function gtag(){dataLayer.push(arguments);}
         gtag('js', new Date());
        gtag('config', '${appInfo.metadata.ga4?.id}');`}
        </script>
      </Helmet>
      <Animated.View
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
        }}
      >
        <AnimationWrapper animation={animatedScreen(animation)}>
          <Render screen={screen} />
          <ErrorComponent />
        </AnimationWrapper>
      </Animated.View>

      {modalScreen && (
        <Animated.View
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: dimension.width,
            height: dimension.height,
            backgroundColor: 'rgba(0,0,0,0.4)',
          }}
        >
          <AnimationWrapper animation={animatedScreen(modalTransition)}>
            <Render screen={modalScreen} />
          </AnimationWrapper>
        </Animated.View>
      )}

      {isShowResetPassword && (
        <Animated.View
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            backgroundColor: '#fff',
          }}
        >
          <AnimationWrapper animation={isForgotPassword.animation}>
            <ResetPassword
              appId={appInfo?.id}
              email={auth.email}
              locale={locale}
            />
          </AnimationWrapper>
        </Animated.View>
      )}

      {isForgotPassword.state && (
        <Animated.View
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            backgroundColor: '#fff',
          }}
        >
          <AnimationWrapper animation={isForgotPassword.animation}>
            <ForgotPassword appId={appInfo?.id} locale={locale} />
          </AnimationWrapper>
        </Animated.View>
      )}
    </Fragment>
  );
}
export default RenderScreen;
